import { format } from 'date-fns';

/**
 * Shared visual + formatting primitives for the Team Member Status surface.
 * Used by the Dashboard widget and the /team-availability accordion so badge
 * colors, dot colors, and the "At {place} since {time}" line stay in sync.
 */

export const STATUS_DISPLAY = {
  IN_OFFICE: {
    label: 'In Office',
    badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    dot: 'bg-emerald-500',
  },
  OUT_IN_FIELD: {
    label: 'Out in the Field',
    badge: 'bg-sky-100 text-sky-800 border-sky-200',
    dot: 'bg-sky-500',
  },
  ENROUTE: {
    label: 'Enroute',
    badge: 'bg-amber-100 text-amber-800 border-amber-200',
    dot: 'bg-amber-500',
  },
  OFF_ISLAND: {
    label: 'Off Island',
    badge: 'bg-slate-200 text-slate-800 border-slate-300',
    dot: 'bg-slate-500',
  },
  UNAVAILABLE: {
    label: 'Unavailable',
    badge: 'bg-rose-100 text-rose-800 border-rose-200',
    dot: 'bg-rose-500',
  },
};

export const NOT_SET_DISPLAY = {
  label: 'Not Set',
  badge: 'bg-gray-100 text-gray-700 border-gray-200',
  dot: 'bg-gray-400',
};

export const getStatusDisplay = (status) => {
  if (!status) return NOT_SET_DISPLAY;
  return STATUS_DISPLAY[status] || NOT_SET_DISPLAY;
};

export const formatTime = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return format(date, 'h:mm a');
};

export const buildContextLine = (status) => {
  if (!status) return null;
  const time = formatTime(status.contextSetAt);
  if (status.officeName) {
    return time ? `At ${status.officeName} since ${time}` : `At ${status.officeName}`;
  }
  if (status.propertyName) {
    return time ? `At ${status.propertyName} since ${time}` : `At ${status.propertyName}`;
  }
  return null;
};
